import { render, staticRenderFns } from "./CenteredContainer.vue?vue&type=template&id=ecef6cd2&scoped=true"
import script from "./CenteredContainer.vue?vue&type=script&lang=js"
export * from "./CenteredContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecef6cd2",
  null
  
)

export default component.exports